import { Circle } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export type WalletFundHealthStatusProps = {
  title: string;
  color: string;
  amount: number;
};

export function WalletFundHealthStatus({
  title,
  color,
  amount,
}: WalletFundHealthStatusProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        gap: 1,
      }}>
      <Typography component="p" variant="body1">
        <Circle sx={{ color: color, fontSize: 14 }} /> {title}
      </Typography>
      <Typography component="p" variant="body1" color={color}>
        {amount}
      </Typography>
    </Box>
  );
}
